import { render, staticRenderFns } from "./ServiceView.vue?vue&type=template&id=f17b5356&lang=pug&"
import script from "./ServiceView.vue?vue&type=script&lang=js&"
export * from "./ServiceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports